import React from "react";
import Head from "next/head";
import { WEBPAGE_TITLE } from "@utils/Constants";
import Page from "@components/Layout/page";
import { ContactUsCard } from "@components/ContactUsCard/ContactUsCard";
import { Leaf } from "@components/Leaf/Leaf";
import styles from "@components/ContactUsCard/ContactUsCard.module.scss";

export default function HafaSamband() {
    return (
        <div style={{ overflowX: "hidden" }}>
            <Page fluid bodyClassName={styles.pageBody}>
                <Head>
                    <title key="site_title">
                        {"Contact Us - " + WEBPAGE_TITLE}
                    </title>
                    <meta
                        property="og:title"
                        content={`${WEBPAGE_TITLE} - Hafðu samband`}
                        key="og:title"
                    />
                    <meta
                        name="og:description"
                        content="Hafðu samband"
                        key="og:description"
                    />
                    <meta name="description" content="Hafðu samband" />
                    <meta name="keywords" content="Hafðu samband" />
                </Head>
                <div className={styles.bgContainer}>
                    <Leaf className={styles.leaf1} plain />
                    <Leaf className={styles.leaf2} plain />
                    <div className={styles.topGradient} />
                    <div
                        style={{
                            position: "relative",
                            zIndex: 1,
                            paddingTop: 80,
                        }}
                    >
                        <ContactUsCard />
                    </div>
                </div>
            </Page>
        </div>
    );
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../locales/${locale}.json`)).default,
        },
    };
}
